import { render } from "./LangSelectBtn.vue?vue&type=template&id=fd6e5320"
import script from "./LangSelectBtn.vue?vue&type=script&lang=js"
export * from "./LangSelectBtn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__